<template>
    <div class="mainSearch" style="width: 245px;">
        <el-input v-model="kw" size="medium" @keyup.enter.native="getSearch" :placeholder="placeholder"></el-input>
        <i class="icon iconfont icon-fangdajing" @click="getSearch"></i>
    </div>
</template>
<script>
    export default {
        props: {
            value: [String, Number],
            placeholder: String
        },
        data() {
            return {
                kw: this.value
            }
        },
        computed: {},
        watch: {
            value(val) {
                this.kw = val
            }
        },
        mounted() {
        },
        methods: {
            getSearch() {
                this.$emit('input', this.kw)
            }
        }
    }
</script>
<style lang="scss" scoped>
    .mainSearch {
        position: relative;
        .el-input ::v-deep  input {
            padding-right: 32px;
        }
        .icon {
            position: absolute;
            right: 9px;
            top: 9px;
            cursor: pointer;
        }
    }
</style>
